module.exports = __webpack_public_path__ + "img/8.30da29e7.png";